import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/default-if-logo.png';
import '../../styles/Demo.css';
import API_BASE from '../../utils/api.js';

export default function Demo() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    email: '',
    name: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  function updateField(key, value) {
    setForm((s) => ({ ...s, [key]: value }));
    if (error) setError('');
  }

  async function submitDemo(e) {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${API_BASE}/api/notifications/demo-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || `Request failed (${res.status})`);
      }

      setSent(true);
    } catch (err) {
      console.error('Failed to send demo request email:', err);
      setError('Something went wrong sending your request. Please try again.');
      setLoading(false);
    }
  }

  return (
    <>
      <img src={logo} alt="InteriorFolio" className="demo-floating-logo" />

      <div className="demo-page">
        <h1 className="demo-title">Need a Demo?</h1>

        <div className="demo-layout">
          <div className="demo-info">
            <div className="demo-icon">&#9654;</div>

            <h3>What Can I Expect?</h3>

            <div className="demo-section">
              <strong>Essential Tools for Team Success</strong>
            </div>

            <div className="demo-section">
              <strong>Brief Discussion</strong>
              <p>
                Engage in a concise conversation about the essential tools your team requires for
                success.
              </p>
            </div>

            <div className="demo-section">
              <strong>Live Demonstration</strong>
              <p>
                Experience a live demonstration of the software, along with a quick how-to guide.
              </p>
            </div>

            <div className="demo-section">
              <strong>Q&amp;A Session</strong>
              <p>We&apos;ll gladly address any questions you may have.</p>
            </div>
          </div>

          {sent ? (
            <div className="demo-form demo-confirmation">
              <div className="demo-confirmation-icon">&#10003;</div>
              <h3>Request Sent!</h3>
              <p>Thanks, {form.name}. Our team will be in touch with you shortly.</p>
              <button type="button" className="demo-next-btn" onClick={() => navigate('/plans')}>
                Back to Plans
              </button>
            </div>
          ) : (
            <form className="demo-form" onSubmit={submitDemo}>
              <h3>Request Your Demo</h3>

              <input
                type="email"
                placeholder="Email Address"
                value={form.email}
                onChange={(e) => updateField('email', e.target.value)}
                required
              />

              <input
                type="text"
                placeholder="First and Last Name"
                value={form.name}
                onChange={(e) => updateField('name', e.target.value)}
                required
              />

              <input
                type="tel"
                placeholder="Phone Number (optional)"
                value={form.phone}
                onChange={(e) => updateField('phone', e.target.value)}
              />

              {error && <p className="demo-error">{error}</p>}

              <button type="submit" className="demo-next-btn" disabled={loading}>
                {loading ? 'Sending…' : 'Next'}
              </button>

              <div className="demo-skip-wrapper">
                <Link to="/plans" className="demo-back-link">&larr; Back to Plans</Link>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
